// ============================================
// Creator State - Images & Gallery (Zustand 기반)
// ============================================

import { useCreatorStore, GALLERY_PAGE_SIZE as _GALLERY_PAGE_SIZE } from '../../../stores/creatorStore.js';

export const GALLERY_PAGE_SIZE = _GALLERY_PAGE_SIZE;

// ============================================
// 이미지 갤러리 상태
// ============================================

export const getGalleryImagePage = () => useCreatorStore.getState().galleryImagePage;
export const getGalleryImageLoading = () => useCreatorStore.getState().galleryImageLoading;
export const getGalleryImageHasMore = () => useCreatorStore.getState().galleryImageHasMore;

export function setGalleryImagePage(page) {
  useCreatorStore.getState().setGalleryImagePage(page);
}

export function setGalleryImageLoading(loading) {
  useCreatorStore.getState().setGalleryImageLoading(loading);
}

export function setGalleryImageHasMore(hasMore) {
  useCreatorStore.getState().setGalleryImageHasMore(hasMore);
}

// ============================================
// 이미지 모델 목록
// ============================================

export const getImageModelList = () => useCreatorStore.getState().imageModelList;

export function setImageModelList(list) {
  useCreatorStore.getState().setImageModelList(list);
}
